/*=========================================================================================
  File Name: index.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
import AdminRoutes from './backend'
import FrontendRoutes from './frontend'
import whiteListRoutes from './whiteList'
import store from '../store'

Vue.use(Router)

const whiteList = whiteListRoutes // Authentication not needed
const allRoutes = []
export const constantRoutes = allRoutes.concat(FrontendRoutes, AdminRoutes) // Concat frontend and backend routes

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes : constantRoutes
})

// adminpanel authentication
router.beforeEach((to, from, next) => {
  const redirectPath = window.location.pathname;

  if (getToken()) {
    // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
    }else if (to.path === '/admin/login') {
      next({ path: '/admin/dashboard' })
    } else {
      const role = store.getters.roles
      const lacksRole = to.matched.some(route => {
        return route.meta.roles && !route.meta.roles.includes(role)
      })

      if (lacksRole == true) {
        if(role == 'admin' || role == 'admin_observer') {
          return next('/admin/dashboard') 
        } else {
          return next('/')  // Aborts the navigation request
        }
      }

      // Route either doesn't require any role or user has one of the 
      // roles specified in the route meta object, continue navigation
      return next()
    }
    
  } else {
    /* has no token*/
    console.log(to.path)
    if(to.path != '/admin/login' && to.path.includes('admin'))
      next('/admin/login');
    else if (to.path.includes('rsvp')) {
      next()
    }
    else if (to.path.includes('privacy')) {
      next()
    }
    else if (to.path.includes('reset-password')) {
      next()
    }
    else if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if(redirectPath !== '/login') {
        next({ path: '/login', query: { from: redirectPath } });
      } else {
        next('/login')
      }
    }
  }
})


router.afterEach(async(to,from) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    let ipAddress= "";
      await fetch("https://api.ipify.org?format=json")
      .then(x => x.json())
      .then(function({ip}){
          ipAddress = ip;
      });
    if(store.state.auth.roles == 'user') {
      store.dispatch('SetLastPageVisited', {last_visited_page: to.fullPath, ip_address: ipAddress})
    }
})
export default router
